/**
 * Post Reactions
 * Emoji reactions on a post (one per user), shown as count chips with an
 * add-reaction palette. Coexists with the heart "like".
 */

import React, { useState } from 'react';
import axios from 'axios';
import { SmilePlus } from 'lucide-react';
import './PostReactions.css';

const EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🔥'];

const PostReactions = ({ postId, reactions: initial = [], currentUserId, isAuthenticated }) => {
  const [reactions, setReactions] = useState(initial);
  const [showPalette, setShowPalette] = useState(false);

  const counts = {};
  reactions.forEach((r) => { counts[r.emoji] = (counts[r.emoji] || 0) + 1; });

  const myReaction = currentUserId
    ? reactions.find((r) => (r.user?._id || r.user)?.toString() === currentUserId?.toString())?.emoji
    : null;

  const react = async (emoji) => {
    if (!isAuthenticated) {
      window.location.href = '/login';
      return;
    }
    setShowPalette(false);
    try {
      const res = await axios.post(`/api/posts/${postId}/react`, { emoji });
      setReactions(res.data.reactions);
    } catch (error) {
      console.error('Error reacting:', error);
    }
  };

  const active = EMOJIS.filter((e) => counts[e] > 0);

  return (
    <div className="post-reactions">
      {active.map((e) => (
        <button
          key={e}
          type="button"
          className={`reaction-chip ${myReaction === e ? 'mine' : ''}`}
          onClick={() => react(e)}
          title="React"
        >
          <span>{e}</span>
          <span className="reaction-count">{counts[e]}</span>
        </button>
      ))}
      <div className="reaction-add">
        <button
          type="button"
          className="reaction-add-btn"
          onClick={() => setShowPalette((v) => !v)}
          title="Add reaction"
        >
          <SmilePlus size={16} />
        </button>
        {showPalette && (
          <div className="reaction-palette">
            {EMOJIS.map((e) => (
              <button
                key={e}
                type="button"
                className={`reaction-option ${myReaction === e ? 'mine' : ''}`}
                onClick={() => react(e)}
              >
                {e}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PostReactions;
